import "./App.css";
import "@radix-ui/themes/styles.css";
import { BrowserRouter } from "react-router-dom";
import Content from "./Content";
import GeneralContex from "./Context/GeneralContex";
import Loader from "./Component/Loader";
import AlertComp from "./Component/Alert";

function App() {
  return (
    <BrowserRouter>
      <GeneralContex>
        <div className="App">
          <Content />
          <Loader />
          <AlertComp />
        </div>
      </GeneralContex>
    </BrowserRouter>
  );
}

export default App;
